import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { FunctionComponent, useMemo } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { getCache } from '@/utils/cache'

const RequireAuthentication: FunctionComponent<RouteProps> = ({
  children,
  component: Component,
  ...rest
}) => {
  const uniqueCode = useMemo(() => {
    return getCache<string>('unique-code')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.path])

  const { token, user, users } = useAuthContext()
  return (
    <Route
      {...rest}
      render={props => {
        const ROUTES_WITHOUT_STATE = ['/autenticacao-dois-fatores']
        const routeState: Record<string, unknown> = {}

        if (!ROUTES_WITHOUT_STATE.includes(props.location.pathname)) {
          routeState.from = props.location
        }

        if (token && user) {
          return Component ? <Component {...props} /> : { children }
        } else if (users) {
          return (
            <Redirect
              to={{
                pathname: uniqueCode ? `/escolha/${uniqueCode}` : '/escolha',
                state: routeState,
              }}
            />
          )
        } else {
          return (
            <Redirect
              to={{
                pathname: uniqueCode ? `/login/${uniqueCode}` : '/login',
                state: routeState,
              }}
            />
          )
        }
      }}
    />
  )
}

export default RequireAuthentication
